var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn-style', _vm.resStyle],attrs:{"type":"bu, responsive]tton"}},[_c('i',{class:[_vm.iconClass, 'mr-2']}),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }